export default "__VITE_ASSET__Bz5ACXk0__"